import { useEffect } from "react"
import i18n from "../i18n"

type GeoData = {
	country: string
	[key: string]: unknown
}

export default function useAutoDetectLanguage() {
	useEffect(() => {
		fetch("https://ipapi.co/json/")
			.then((res) => res.json())
			.then((data) => {
				const geoData = data as GeoData
				if (geoData.country === "BR") {
					i18n.changeLanguage("pt")
					return
				}
				const lng = localStorage.getItem("lng")
				if (lng) {
					i18n.changeLanguage(lng)
					return
				}
				i18n.changeLanguage("en")
			})
			.catch(() => {
				i18n.changeLanguage("en")
			})
	}, [])
}
